export default[
    {
        path: '/boletins/tabela/cadastro',
        name: 'cadastro de boletins', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/boletins/tabela/lista',
        name: 'lista do boletim com tabela', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/boletins/tabela/editar/:id',
        name: 'editar boletins', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]